import request from '@/utils/request';
// 专区列表
export function queryExampaperList(data :{[key: string]: any} = {}) {
    return request.post({
        url: 'contentapi/exampaper/query',
        data: {
            channel_source: 'pc',
            ...data,
          },
    });
}
// 试卷详情
export function getSinglePaperDetail(data :{[key: string]: any} = {}) {
    return request.get({
        url: 'basicapi/v1/paper/detail',
        data: {
            channel_source: 'pc',
            ...data,
        },
    });
}

// 获取挽留图片
export function getHelpPic(data :{[key: string]: any} = {}) {
    return request.get({
        url: 'basicapi/v1/common/config',
        data,
    });
}
// 
// 下载pdf
export function singlePaperDownload(data :{[key: string]: any} = {}) {
    return request.post({
        url: 'performapi/v1/papers/download',
        data: {
            channel_source: 'pc',
            ...data,
        },
    });
}

// 获取url地址
export function getPdfOssAddress(data :{[key: string]: any} = {}) {
    return request.post({
        url: 'performapi/v1/papers/file',
        data,
    });
}

// 试卷次数扣减 
export function paperDownloadExchange(data :{[key: string]: any} = {}) {
    return request.post({
        url: 'basicapi/v1/activation/paper-download-exchange',
        data,
    });
}

// 下载记录上报 
export function paperUploadReport(data :{[key: string]: any} = {}) {
    return request.post({
        url: 'basicapi/v1/user/download/upload',
        data:{
            channel_source: 'pc',
            ... data
        }
    });
}